<template>
  <v-form
    v-model="valid"
    class="mx-auto py-5"
    style="width: 80%; height: 100%;"
  >
    <v-container v-for="(element, index) in elements" :key="index" fluid class="py-0">
      <p
        v-if="element.type === 'message'"
        class="pb-5"
      >
        {{element.name}}
      </p>

      <v-text-field
        v-model="data[element.name]"
        v-if="element.type === 'text' && (!element.visibleIf || checkVisiblitity(element.visibleIf))"
        class="pb-5"
        :label="element.name"
        :name="element.name"
        :rules="element.rules||[v=>!!v||'必須項目です']"
        @change="updateObject()"
        @keyup.enter="save"
      ></v-text-field>

      <v-select
        v-model="data[element.name]"
        v-if="element.type === 'select' && (!element.visibleIf || checkVisiblitity(element.visibleIf))"
        class="pb-5"
        :items="element.choices"
        :label="element.name"
        :name="element.name"
        :rules="element.rules||[v=>!!v||'必須項目です']"
        :multiple="element.multiple"
        @change="updateObject()"
        @keyup.enter="save"
      ></v-select>

      <v-radio-group v-model="data[element.name]"
        v-if="element.type === 'radio' && (!element.visibleIf || checkVisiblitity(element.visibleIf))"
        class="pb-5"
        :label="element.name"
        :name="element.name"
        :rules="element.rules||[v=>!!v||'必須項目です']"
        @change="updateObject()"
        @keyup.enter="save"
      >
        <v-radio
          v-for="(choice, index) in element.choices"
          :key="index"
          :label="choice"
          :value="choice"
          @change="updateObject()"
        ></v-radio>
      </v-radio-group>

      <div v-if="element.type === 'checkbox' && (!element.visibleIf || checkVisiblitity(element.visibleIf))">
        <p>
          {{ element.name }}
        </p>
        <div v-for="(choice,i) in element.choices" :key="choice" class="py-0" style="display: flex;">
          <input
            class="vuetify-like-checkbox"
            v-model="data[element.name]"
            :id="'choice' + i"
            type="checkbox"
            :value="choice"
            @change="updateObject()"
          >
          <label :for="'choice' + i">{{ choice }}</label>
        </div>
      </div>
    </v-container>
    <v-btn
      color="primary"
      class="white--text mb-5"
      :disabled="!valid||!touched"
      @click="save"
    >
      保存
    </v-btn>
  </v-form>
</template>

<script>
// firestoreをインポート
import firebase from "firebase/app"
import "firebase/firestore"
import Vue from 'vue'
import Toasted from "vue-toasted";
Vue.use(Toasted,{iconPack : 'material'})

export default {
  name: 'AttributionSetting',
  props: {
    initialMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      data: {},
      touched: false,
      additionalAttr: {},
    }
  },
  created() {
    let self = this

    // 最初に開いていてかつlocalStorageにchannelの値がある場合、追加アンケートなどの取得表示
    const channel = localStorage.getItem('channel')
    if (this.initialMode && channel && channel !== 'default') {
      firebase.firestore().doc(`/0/config/attributionDefs/${channel}`).get().then((doc) => {
        if (doc.exists) {
          self.additionalAttr = JSON.parse(doc.data().def);
        }
      })
    }

    // 既存の入力済みデータの取得
    firebase.firestore().collection('userAttribute').doc(self.uid).get().then((doc) => {
      const data = doc.data()
      if (doc.exists) {
        // updatedAt, createdAtは不要なのでそれ以外を入れる
        self.data = Object.keys(data).filter((key) => key !== 'updatedAt' && key !== 'createdAt').reduce((obj, key) => {
          obj[key] = data[key];
          return obj;
        }, {});
      } else {
        // this.dataを埋めたい
        self.elements.forEach((element) => {
          if (element.type !== 'message') {
            if (element.type === 'checkbox') {
              // 配列にするだけ
              Vue.set(self.data, element.name, [])
            }
            else {
              Vue.set(self.data, element.name, '')
            }
          }
        })
      }
    })
  },
  mounted() {
  },
  methods: {
    updateObject() {
      // visiblityが再評価されるようにする
      this.$forceUpdate()
      // 一度でも変更があったらtouchedをtrueにする
      this.touched = true
      // TODO: 変数としてdataを渡せば上手く行ったりしないか...？その場合 dataにsetを使ったりする...？
    },
    // visibleIfの検証
    checkVisiblitity(rule) {
      // そもそもruleがない場合はtrueを返す
      if (!rule) {
        return true
      }
      // ruleはこのような形式
      // {"name": "趣味","value": ["スポーツ","音楽","映画"],"operator": "oneof"}

      // まずはnameでdataを取得
      const data = this.data[rule.name]
      // valueは配列
      const value = rule.value
      // operatorはoneof, eq, neq, gt, gte, lt, lte
      const operator = rule.operator

      // operatorごとに処理を分ける
      switch (operator) {
        case "oneof":
          // 配列の中にdataが含まれるか確認
          return value.includes(data)
        case "eq":
          // dataとvalueが等しいか確認
          return data === value[0]
        case "neq":
          // dataとvalueが等しくないか確認
          return data !== value[0]
        // TODO: 以下は未実装。数値などの場合に使う？

        // case "gt":
        //   // dataがvalueより大きいか確認
        //   return data > value[0]
        // case "gte":
        //   // dataがvalue以上か確認
        //   return data >= value[0]
        // case "lt":
        //   // dataがvalueより小さいか確認
        //   return data < value[0]
        // case "lte":
        //   // dataがvalue以下か確認
        //   return data <= value[0]
        default:
          // 未知のoperatorが渡された場合、falseを返す
          return false
        }
    },
    save() {
      if (!this.valid) {
        return
      }
      this.updateData()
      this.$store.dispatch('auth/setAttributionModalClosed');
    },
    updateData() {
      // 実際に送信する段で checkVisiblitity()を使ってinvisibleなはずのデータは削除する
      const filteredData = Object.keys(this.data).filter((key) => {
        const element = this.elements.find((element) => element.name === key)
        // elementがない場合はfalseを返す
        return element && (!element.visibleIf || this.checkVisiblitity(element.visibleIf))
      }).reduce((obj, key) => {
        obj[key] = this.data[key];
        return obj;
      }, {});
      if (this.initialMode) {
        firebase.firestore().collection('userAttribute').doc(this.uid).set(
          {
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            uid: this.uid,
            isNotAnswered: false,
            ...filteredData
          }
        ).then(() => {
          this.showToast()
          this.touched = false
        }).catch((error) => {
          console.error(error)
        })
      } else {
        firebase.firestore().collection('userAttribute').doc(this.uid).update(
          {
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            isNotAnswered: false,
            ...filteredData
          }
        ).then(() => {
          this.showToast()
          this.touched = false
        }).catch((error) => {
          console.error(error)
        })
      }
    },
    showToast(message="保存しました"){
      this.$toasted.success(message, {
        theme: "bubble", 
        position: "top-center", 
        duration : 5000,
      });
    },
    showWarningToast(message="エラーが発生しました。現在担当者が確認中です。お手数ですが、しばらく時間をおいてから再度お試しください。"){
      this.$toasted.warning(message, {
        theme: "bubble", 
        position: "top-center", 
        duration : 5000,
      });
    },
  },
  watch: {
  },
  computed: {
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    uid() {
      return this.$store.state.auth.user.uid || '';
    },
    attributionDef() {
      return this.$store.state.auth.data.attributionDef;
    },
    elements() {
      if (this.initialMode) {
        return this.attributionDef.elements.concat(this.additionalAttr?.elements || [])
      } else {
        return this.attributionDef.elements.filter((element)=>!element.skippable)
      }
    },
  },
}
</script>

<style>
.menuable__content__active .v-list-item__title {
  white-space: pre-wrap !important;
}
.v-select__selection {
  white-space: pre-wrap !important;
}
</style>

<style scoped>
.vuetify-like-checkbox{
  border-radius: 50%;
  cursor: pointer;
  height: 19px;
  transition: inherit;
  width: 19px;
  margin: 7px;
}
.vuetify-like-checkbox::after{
  border-radius: inherit;
  bottom: 0;
  content: "";
  opacity: 0.2;
  left: 0;
  right: 0;
  top: 0;
  transform-origin: center center;
  transform: scale(0.2);
  transition: inherit;
}
/* これと兄弟のラベル */
.vuetify-like-checkbox + label{
  color: rgba(0, 0, 0, 0.6);
}
</style>